import { registry, SUPPORTED_TYPES, widgetFor } from "./registry.js"
import { validateEnvelope, EXERCISE_SCHEMA } from "./validate.js"
import { translator } from "./shared/i18n.js"
import { renderUnavailable } from "./shared/chrome.js"
import { isElement } from "./shared/dom.js"
import { RESULT_SCHEMA } from "./shared/result.js"

const NOOP = () => {}

function failure(error) {
  return { ok: false, error, unmount: NOOP }
}

function inert(node, t, error) {
  renderUnavailable(node, t)
  return {
    ok: false,
    error,
    unmount() {
      while (node.firstChild) node.removeChild(node.firstChild)
    }
  }
}

export function mountExercise(exercise, node, options = {}) {
  if (!isElement(node)) {
    return failure({ code: "invalid_mount", message: "Mount target must be an element" })
  }

  const settings = options && typeof options === "object" ? options : {}
  const t = translator(settings.locale)

  const envelopeError = validateEnvelope(exercise, SUPPORTED_TYPES)
  if (envelopeError) return inert(node, t, envelopeError)

  const widget = widgetFor(exercise.type)
  const typeError = widget.validate(exercise)
  if (typeError) return inert(node, t, typeError)

  const callbacks = settings.callbacks && typeof settings.callbacks === "object"
    ? settings.callbacks
    : {}

  const resolved = {
    t,
    locale: t.locale,
    now: typeof settings.now === "function" ? settings.now : () => Date.now(),
    random: typeof settings.random === "function" ? settings.random : Math.random,
    callbacks
  }

  let handle
  try {
    handle = widget.mount(exercise, node, resolved)
  } catch (error) {
    return inert(node, t, {
      code: "mount_failed",
      message: error && error.message ? error.message : "Widget failed to mount"
    })
  }

  let unmounted = false

  return {
    ok: true,
    type: exercise.type,
    locale: t.locale,
    unmount() {
      if (unmounted) return
      unmounted = true
      try {
        handle.unmount()
      } catch {
        /* no-op */
      }
    }
  }
}

export { registry, SUPPORTED_TYPES, EXERCISE_SCHEMA, RESULT_SCHEMA }
export default mountExercise
